var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg116Youtube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.883,
    height: 24,
    viewBox: "0 0 33.883 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_116-youtube",
    "data-name": "116-youtube",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67396",
    "data-name": "Group 67396",
    transform: "translate(-0.006 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67395",
    "data-name": "Group 67395",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80459",
    "data-name": "Path 80459",
    d: "M33.127,78.1l.042.277a4.3,4.3,0,0,0-2.92-2.982l-.03-.007c-2.641-.717-13.271-.717-13.271-.717s-10.6-.014-13.271.717A4.3,4.3,0,0,0,.738,78.343l-.007.03A47.228,47.228,0,0,0,.775,95.239l-.044-.28a4.3,4.3,0,0,0,2.92,2.982l.03.007c2.639.719,13.271.719,13.271.719s10.6,0,13.271-.719a4.3,4.3,0,0,0,2.942-2.959l.007-.03a44.139,44.139,0,0,0,.706-7.974v-.637a45.538,45.538,0,0,0-.75-8.253ZM13.558,91.821v-10.3L22.4,86.68Z",
    transform: "translate(0.006 -74.666)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg116Youtube);
export default __webpack_public_path__ + "static/media/116-youtube.b78a4e0c414fb8e59cf26eb07dc301f2.svg";
export { ForwardRef as ReactComponent };